import { render } from "./UserPage.vue?vue&type=template&id=7c075d78"
import script from "./UserPage.vue?vue&type=script&lang=js"
export * from "./UserPage.vue?vue&type=script&lang=js"

import "./UserPage.vue?vue&type=style&index=0&id=7c075d78&lang=css"
script.render = render

export default script